<template>
  <b-container>
    <b-row class="col-sm-12 col-md-12 col-lg-8 story ">
      <div class="numbers ">
        <blockquote>
          <p>
            Meilensteine, bei denen ein Termin eingetragen ist:
            <span>{{ count.has_date_count }}</span>
          </p>
        </blockquote>
        <blockquote>
          <p>
            Meilensteine, bei denen kein Termin eingetragen ist:
            <span>{{ count.no_date_count }}</span>
          </p>
        </blockquote>
      </div>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "OZGMilestoneCount",
  data() {
    return {
      count: {}
    };
  },
  watch: {
    countNoTimelineDate: function(newVal) {
      var impl = {};

      for (var x in newVal) {
        // Shows only the explicitly set index of "5", and ignores 0-4
        impl[newVal[x].name] = newVal[x].count;
      }

      this.count = impl;
    }
  },
  apollo: {
    $client: "ozgClient",
    countNoTimelineDate: {
      query() {
        return require("../../graphql/countNoTimelineDate.gql");
      }
    }
  }
};
</script>

<style scoped></style>
